import React from "react";
import { Form, Input, Select, Row, Col } from "antd";
import {
  listOfMeasurement,
  listOfMedication,
  medicineTypes,
} from "../common/helper/MedicineList";

const MedicineForm = ({ form }) => {
  return (
    <React.Fragment>
      Medication Administrator
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="manufacturer"
              label="Manufacturer"
              rules={[
                {
                  required: true,
                  message: "Please input the manufacturer name!",
                },
              ]}
            >
              <Input placeholder="Enter manufacturer name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="medicine"
              label="Medicine"
              rules={[
                { required: true, message: "Please input the medicine name!" },
              ]}
            >
              <Select placeholder="Select medicine">
                {Object.entries(listOfMedication).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="unit_of_measurement"
              label="Unit of Measurement"
              rules={[
                {
                  required: true,
                  message: "Please select a unit of measurement!",
                },
              ]}
            >
              <Select placeholder="Select unit of measurement">
                {Object.entries(listOfMeasurement).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="medicine_type"
              label="Type"
              rules={[
                { required: true, message: "Please select a medicine type!" },
              ]}
            >
              <Select placeholder="Select medicine type">
                {Object.entries(medicineTypes).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true, message: "Please select a status!" }]}
            >
              <Select placeholder="Select status">
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="dosage_route"
              label="Dosage Route"
              rules={[
                { required: true, message: "Please input the dosage route!" },
              ]}
            >
              <Select placeholder="Select dosage route">
                <Select.Option value="oral">Oral</Select.Option>
                <Select.Option value="topical">Topical</Select.Option>
                <Select.Option value="inhalation">Inhalation</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="stock_quantity"
              label="Stock Quantity"
              rules={[
                { required: true, message: "Please input the stock quantity!" },
              ]}
            >
              <Input type="number" placeholder="Enter stock quantity" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="threshold"
              label="Threshold"
              rules={[
                { required: true, message: "Please input the threshold!" },
              ]}
            >
              <Input type="number" placeholder="Enter threshold" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default MedicineForm;
